import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, unref, watch } from 'vue';

import BootstrapButtonDropdown from './bootstrap-button-dropdown.vue';
import PeriodFilterBox from './period-filter-box.vue';
import type { FixedPeriodTableType } from './period-filter-control';
import {
    DefaultFixedPeriod, DefaultFixedPeriodTable, NullFixedPeriod, SelectedPeriod,
    TuttiFixedPeriod,
} from './period-filter-control';


export default /*#__PURE__*/_defineComponent({
  __name: 'period-filter-control',
  props: {
    periodTable: null,
    initialPeriod: null,
    allowTutti: { type: Boolean },
    modelValue: null,
    currentlySelected: null,
    reset: null,
    customButton: { type: Boolean }
  },
  emits: ["update:modelValue", "update:currentlySelected", "custom-button-click"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: SelectedPeriod | undefined): void;
    (event: 'update:currentlySelected', value: SelectedPeriod | undefined): void;
    (event: 'custom-button-click', value: undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    periodTable?: FixedPeriodTableType;
    initialPeriod?: string;
    allowTutti?: boolean;
    modelValue?: SelectedPeriod;
    currentlySelected?: SelectedPeriod;
    reset?: number;
    customButton?: boolean;
}


//eslint-disable-next-line no-spaced-func


const selectedValue = ref(props.modelValue ?? props.currentlySelected);
const highlightPeriod = ref(props.initialPeriod || DefaultFixedPeriod);
const selectedPeriod = ref(unref(highlightPeriod));
const periodTableRef = computed(() => props.periodTable ?? DefaultFixedPeriodTable);

function emitUpdate() {
    const _selectedValue = unref(selectedValue);
    if(!SelectedPeriod.compare(props.modelValue, _selectedValue)) {
        emit('update:modelValue', _selectedValue);
    }
}

function applyFixedPeriod(period: string) {
    selectedValue.value = SelectedPeriod.fromFixedPeriod(undefined, period, -1);
    highlightPeriod.value = period;
    selectedPeriod.value = period;
    emitUpdate();
}

function applyUserPeriod(_emit: boolean) {
    const _selectedValue = unref(selectedValue)?.toMoment();
    highlightPeriod.value = NullFixedPeriod;
    const _selectedPeriod = unref(selectedPeriod);
    if(_selectedPeriod !== NullFixedPeriod) {
        //if user selected the same period it would be selected from menu - highlight it
        const fixedPeriod = SelectedPeriod.fromFixedPeriod2(undefined, _selectedPeriod, -1);
        if((fixedPeriod.from.getTime() === _selectedValue?.from?.getTime())
            && (fixedPeriod.to.getTime() === _selectedValue?.to?.getTime())) {
            highlightPeriod.value = _selectedPeriod;
        }
    }
    if(_emit) {
        emitUpdate();
    }
}

watch(() => props.modelValue, () => {
    selectedValue.value = props.modelValue;
    applyUserPeriod(false);
});

watch(() => props.reset, () => {
    selectedValue.value = props.modelValue;
    selectedPeriod.value = props.initialPeriod || DefaultFixedPeriod;
    applyUserPeriod(false);
});

watch(() => props.currentlySelected, (val) => {
    const _selectedValue = unref(selectedValue);
    if(val && !SelectedPeriod.compare(val, _selectedValue)) {
        selectedValue.value = SelectedPeriod.cloneObject(val);
        applyUserPeriod(false);
    }
}, { deep: true });

watch(selectedValue, (_selectedValue) => {
    if(!SelectedPeriod.compare(props.currentlySelected, _selectedValue)) {
        emit('update:currentlySelected', _selectedValue);
    }
}, { deep: true });

onMounted(() => {
    // may initialize default
    applyUserPeriod(true);
    emit('update:currentlySelected', unref(selectedValue));
});

return { __sfc: true,props, emit, selectedValue, highlightPeriod, selectedPeriod, periodTableRef, emitUpdate, applyFixedPeriod, applyUserPeriod, BootstrapButtonDropdown, PeriodFilterBox, DefaultFixedPeriod, TuttiFixedPeriod }
}

})